<form #policyRuleForm="ngForm" (ngSubmit)="policyRuleForm.valid && close()">
    <div class="mon-dialog-body-with-footer auto-scroll policy-form-dialogs-rule px-3">
        <div class="row">
            <div class="col-48 mt-4">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('name')?.invalid && (policyRuleForm.form.get('name')?.dirty || policyRuleForm.submitted )}">
                    <label class="col-form-label text-bold"><span translate>Rule name</span>*</label>
                    <div>
                        <form-field-input name="name" [(ngModel)]="cRule.name" [required]="true"></form-field-input>
                        <form-field-errors [input]="policyRuleForm.form.get('name')" offset="0"></form-field-errors>
                    </div>
                </div>
            </div>

            <div class="col-48 mt-2 sub-entries" *ngIf="subEntry?.options?.length > 0">
                <div class="form-group">
                    <label class="col-form-label text-bold">{{subEntry.labelTxt}}</label><br/>

                    <label class="checkbox-inline inline-block">
                        <input type="checkbox"
                               name="areAllSubEntriesSelectedCheckbox"
                               [checked]="areAllSubEntriesSelected"
                               (click)="selectAllSubEntries()"/>
                        {{subEntry.allTxt}}
                    </label>
                    <form-field-checkbox-in-line (ngModelChange)="checkSelectedSubEntries()"
                                                 class="block"
                                                 [options]="subEntry.options" returnValue="value"
                                                 [(ngModel)]="cRule.sub_entry"
                                                 name="subEntry">
                    </form-field-checkbox-in-line>
                </div>
            </div>
            <div class="col-48 mt-2">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('query')?.invalid && (policyRuleForm.form.get('query')?.dirty || policyRuleForm.submitted )}">
                    <label for="query" class="col-form-label text-bold">{{ label }}</label> ({{ CharacterLabel | translate }}):
                    <div class="input-group">
                        <mon-action-menu
                            *ngIf="cRule.operator"
                            class="rule-menu-action"
                            [monActionMenuItems]="dropdownOptions"
                            [monActionMenuClass]="'menu-panel-left-align'"
                            >{{selectedOption?.translation}}</mon-action-menu>
                        <input name="query"
                               data-test="query-starts-with"
                               min="0"
                               [required]="true"
                               [(ngModel)]="cRule.query"
                               #queryFormControl="ngModel"
                               id="query"
                               type="number"
                               [min]="0"
                               class="form-control">
                    </div>
                    <form-field-errors [input]="queryFormControl" offset="0"></form-field-errors>
                </div>
            </div>
        </div>
    </div>
    <div class="mon-dialog-footer text-right">
        <button
                [disabled]="policyRuleForm.invalid"
                data-test="save-button"
                class="btn btn-border-radius btn-secondary"
                type="submit"
                translate>
            Save
        </button>
    </div>
</form>
